import React from 'react';
import { Box, Dialog, DialogContent, Divider, IconButton, Typography } from '@mui/material';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import CloseIcon from '@mui/icons-material/Close';

import Applied from './Applied';
import { useLoader } from '../../common/GlobalLoader';

const ACCENT = '#2f6bff';

/**
 * Reusable "Apply for Leave" modal. Wraps the shared <Applied> form in the same
 * FORTHEYE-style Dialog used on the Leave Management page, so any screen (the
 * Leaves page, the Attendance summary card's LOP-days tile, …) can trigger a
 * leave application without leaving the page.
 *
 * On a successful submit, <Applied> calls onClose after a short delay; the
 * useEmpLeaveRequest mutation invalidates the leave + attendance queries so the
 * caller's data (e.g. the LOP-days count) refreshes automatically.
 */
const ApplyLeaveModal = ({ open, onClose, prefillDate }) => {
  const { isLoading: isSubmittingLeave } = useLoader();

  // Block a mid-submit dismiss (backdrop / Esc) so the request isn't orphaned;
  // the explicit close button is disabled separately while submitting.
  const handleDialogClose = (_event, reason) => {
    if (isSubmittingLeave && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      return;
    }
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: '22px', boxShadow: '0 24px 60px rgba(17,24,39,0.18)' } }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pt: 2.5, pb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box sx={{ width: 40, height: 40, borderRadius: '12px', bgcolor: `${ACCENT}14`, color: ACCENT, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <BeachAccessIcon fontSize="small" />
          </Box>
          <Typography variant="h6" fontWeight={700}>Apply for Leave</Typography>
        </Box>
        <IconButton onClick={() => onClose?.()} size="small" disabled={isSubmittingLeave}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ borderColor: '#eef0f4' }} />
      <DialogContent sx={{ borderBottom: 'none' }}>
        <Applied onClose={onClose} prefillDate={prefillDate} />
      </DialogContent>
    </Dialog>
  );
};

export default ApplyLeaveModal;
